(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["jta-hero-copy"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target instanceof Element && event.target.closest('[data-jta-cta]');
    const target = link && document.getElementById('jta-comprar');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["jta-quantity-offers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jta-quantity-offers')) {
    customElements.define(
      'jta-quantity-offers',
      class extends HTMLElement {
        connectedCallback() {
          this.onChange = (event) => {
            if (event.target.type !== 'radio') return;
            this.select(Number(event.target.value));
          };
          this.addEventListener('change', this.onChange);
          this.section = this.closest('.shopify-section, dialog');
          this.onVariant = (event) => {
            if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
            event.promise
              ?.then(({ detail }) => {
                const fresh = detail?.html?.querySelector(`jta-quantity-offers[data-block-id="${this.dataset.blockId}"]`);
                if (!fresh) return;
                const current = Number(this.querySelector('input:checked')?.value || 1);
                this.innerHTML = fresh.innerHTML;
                const radio = this.querySelector(`input[value="${current}"]`);
                if (radio) radio.checked = true;
                this.select(current);
              })
              .catch(() => {});
          };
          this.section?.addEventListener('shopify:product:select', this.onVariant);
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.onChange);
          this.section?.removeEventListener('shopify:product:select', this.onVariant);
        }

        select(quantity) {
          this.querySelectorAll('.jta-qty__option').forEach((option) => {
            option.classList.toggle('is-selected', Number(option.querySelector('input').value) === quantity);
          });
          const scope = this.closest('.shopify-section') || document;
          const selector = scope.querySelector('quantity-selector-component');
          if (selector && typeof selector.setValue === 'function') {
            selector.setValue(String(quantity));
            selector.updateButtonStates?.();
            selector.onQuantityChange?.();
            return;
          }
          const input = scope.querySelector('input[name="quantity"]');
          if (input) {
            input.value = String(quantity);
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["jta-stock-urgency"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jta-stock-urgency')) {
    customElements.define(
      'jta-stock-urgency',
      class extends HTMLElement {
        connectedCallback() {
          if (this.closest('product-card')) return;
          this.section = this.closest('.shopify-section, dialog');
          this.onSelect = (event) => {
            if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
            event.promise
              ?.then(({ detail }) => {
                const fresh = detail?.html?.querySelector(`jta-stock-urgency[data-block-id="${this.dataset.blockId}"]`);
                if (fresh) this.innerHTML = fresh.innerHTML;
              })
              .catch(() => {});
          };
          this.section?.addEventListener('shopify:product:select', this.onSelect);
        }

        disconnectedCallback() {
          this.section?.removeEventListener('shopify:product:select', this.onSelect);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
